import React from "react";
import styles from "./topRightMapControl.module.scss";

const TopRightMapControl = (props) => {
  const { right = "10px", top = "7px" } = props;

  return (
    <div className={styles.map_control_container} style={{ right: right, top: top }}>
      <div className={styles.containerItems}>{props.children}</div>
    </div>
  );
};

export default React.memo(TopRightMapControl);
